import { combineReducers } from 'redux';
import schedules from './schedules';
import shifts from './shifts';

export default combineReducers({ schedules, shifts });
